export const asArray = <T>(itemOrItems: T | T[]): T[] => (Array.isArray(itemOrItems) ? itemOrItems : [itemOrItems]);

export const isPrimitiveArray = (value: any): boolean =>
    value &&
    Array.isArray(value) &&
    !value.some(v => v && typeof v !== 'string' && typeof v !== 'number' && typeof v !== 'boolean');
